import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type HomeRoutes = {
    home: Route
    fetchLongUrl: Route
    services: Route
    team: Route
    staffProfile: Route
}

export const homeRoutes: HomeRoutes = {
    home: {
        path: 'dashboard/home',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-home/page-home.component').then(
                (m) => m.PageHomeComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    fetchLongUrl: {
        path: 's/:id',
        loadComponent: () =>
            import('../page-short-url-handler/page-short-url-handler.component').then(
                (c) => c.PageShortUrlHandlerComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    services: {
        path: 'dashboard/services',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.service.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-shop-services/page-shop-services.component').then(
                (m) => m.PageShopServicesComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    team: {
        path: 'dashboard/team',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.staff.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-team/page-team.component').then(
                (m) => m.PageTeamComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    staffProfile: {
        path: 'dashboard/staff-profile',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('@baboor/baboor-main').then((m) => m.StaffProfileComponent),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
